import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import {
  CreateMarathonAgreementsByMarathonIdBody,
  CreateMarathonAgreementsByMarathonIdRes,
  GetAllMarathonAgreementsByMarathonIdParams,
  GetAllMarathonAgreementsByMarathonIdRes,
  GetMarathonAgreementsByMarathonIdParams,
  GetMarathonAgreementsByMarathonIdRes,
  UpdateMarathonAgreementsByMarathonIdBody,
  UpdateMarathonAgreementsByMarathonIdRes
} from "./types";

export const offerAgreementsAPI = {
  getMarathonAgreementsByMarathonId: async (
    params: GetMarathonAgreementsByMarathonIdParams,
  ): Promise<GetMarathonAgreementsByMarathonIdRes> => {
    const response = await axiosApi.get<GetMarathonAgreementsByMarathonIdRes>(
      `/agreements/marathon/${params.marathonId}`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getAllMarathonAgreementsByMarathonId: async (
    params: GetAllMarathonAgreementsByMarathonIdParams,
  ): Promise<GetAllMarathonAgreementsByMarathonIdRes> => {
    const response = await axiosApi.get<GetAllMarathonAgreementsByMarathonIdRes>(
      `/agreements/marathon/${params.marathonId}/all`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  createMarathonAgreementsByMarathonId: async (
    { marathonId, file, languageCode }: CreateMarathonAgreementsByMarathonIdBody,
  ): Promise<CreateMarathonAgreementsByMarathonIdRes> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("languageCode", languageCode);

    const response = await axiosApi.post<CreateMarathonAgreementsByMarathonIdRes>(
      `/agreements/marathon/${marathonId}`,
      formData,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  updateMarathonAgreementsByMarathonId: async (
    { agreementId, file }: UpdateMarathonAgreementsByMarathonIdBody,
  ): Promise<UpdateMarathonAgreementsByMarathonIdRes> => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosApi.put<UpdateMarathonAgreementsByMarathonIdRes>(
      `/agreements/marathon/${agreementId}`,
      formData,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
}